import { render, staticRenderFns } from "./ServiceCatalogItems.vue?vue&type=template&id=0694e832&scoped=true&"
import script from "./ServiceCatalogItems.vue?vue&type=script&lang=ts&"
export * from "./ServiceCatalogItems.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCatalogItems.vue?vue&type=style&index=0&id=0694e832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0694e832",
  null
  
)

export default component.exports